import {
    React,
    PropTypes,
    TextField,
    UI,
    useIntl,
    isSubmittingSelector,
    useSelector,
} from '../../../../../dependencies';

const { InputWrapper } = UI;

const Username = ({ formId }) => {
    const intl = useIntl();
    const isSubmitting = useSelector(isSubmittingSelector(formId));

    return (
        <InputWrapper gridArea="username">
            <TextField
                name="username"
                label={intl.formatMessage({
                    id: 'export.recurring.form.username.label',
                })}
                placeholder={intl.formatMessage({
                    id: 'export.recurring.form.username.placeholder',
                })}
                disabled={isSubmitting}
                type="text"
                autoComplete="disabled"
            />
        </InputWrapper>
    );
};

Username.propTypes = {
    formId: PropTypes.string.isRequired,
};

export default Username;
